import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=a4370cdc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4370cdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4370cdc')) {
      api.createRecord('a4370cdc', component.options)
    } else {
      api.reload('a4370cdc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=a4370cdc&scoped=true&", function () {
      api.rerender('a4370cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rnr3mmNAWr8H/JS/comp/SearchFilterTokens.vue"
export default component.exports